export function addScript (url: string, onloadFunction: () => void, onErrorFunction: OnErrorEventHandlerNonNull) {
  const newScript = document.createElement('script')
  newScript.type = 'text/javascript'

  if (onloadFunction) {
    newScript.onload = onloadFunction
  }
  newScript.onerror = onErrorFunction

  if (document.currentScript && document.currentScript.parentNode) {
    document.currentScript.parentNode.insertBefore(newScript, document.currentScript)
  } else {
    document.head.appendChild(newScript)
  }
  newScript.src = url
}
